import { ActivityType } from 'gql';
import { defineMessages, MessageDescriptor } from 'react-intl';

export const activityTypePluralOrSigleMessages: Record<ActivityType, MessageDescriptor> = defineMessages({
  [ActivityType.Distribution]: { id: '{activityCount, plural, zero {Distributions} one {Distribution} other {Distributions}}' },
  [ActivityType.Intervention]: { id: '{activityCount, plural, zero {Interventions} one {Intervention} other {Interventions}}' },
  [ActivityType.Presentation]: { id: '{activityCount, plural, zero {Presentations} one {Presentation} other {Presentations}}' },
  [ActivityType.Routine]: { id: '{activityCount, plural, zero {Routines} one {Routine} other {Routines}}' },
  [ActivityType.Meeting]: { id: '{activityCount, plural, zero {Meetings} one {Meeting} other {Meetings}}' },
});